// @flow
// This polyfill inclusion must be the first line in src/index.js
import 'react-app-polyfill/ie9';
import { loadComponents } from 'loadable-components';
import React from 'react';
import { hydrate, render } from 'react-dom';
import AppWrapper from './AppWrapper';
import { init } from './helpers/board';
import {
  connectRouter,
  history,
  Provider,
  rootReducer,
  Router,
  store
} from './helpers/redux';
import * as serviceWorker from './helpers/serviceWorker';
//import { ConfigureAmplify } from './helpers/amplify';
//import { ConfigureAmplifyForPatient } from './helpers/patient-aws-config';
//import 'video-react/dist/video-react.css';
import './index.css';
import { toast } from 'react-toastify';
import './toastify.css';

let isOnline;

toast.configure({
  // autoClose: 8000,
  draggable: false,
  position: 'top-center',
  hideProgressBar: true,
  closeOnClick: false,
  pauseOnHover: true
  // closeButton: false,
});

if (window.electron) {
  const { webFrame } = window.electron;
  // es-lint-disable-next-line
  if (webFrame) {
    if (window.screen.width === 1280 && window.screen.height === 800) {
      webFrame.setZoomFactor(1);
    } else {
      webFrame.setZoomFactor(1.5);
    }
  }
}

//ConfigureAmplify();
//ConfigureAmplifyForPatient();

init();

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  loadComponents().then(() => {
    hydrate(
      // This redundant pattern is intentional, for hot reload
      <Provider store={store}>
        <Router history={history}>
          <AppWrapper store={store} history={history} />
        </Router>
      </Provider>,
      rootElement
    );
  });
} else {
  if (module.hot) {
    module.hot.accept('./AppWrapper', () => {
      render(
        // This redundant pattern is intentional, for hot reload
        <Provider store={store}>
          <Router history={history}>
            <AppWrapper store={store} history={history} />
          </Router>
        </Provider>,
        rootElement
      );
    });

    module.hot.accept('./reducers', () => {
      store.replaceReducer(connectRouter(history)(rootReducer));
    });
  }
  render(
    // This redundant pattern is intentional, for hot reload
    <Provider store={store}>
      <Router history={history}>
        <AppWrapper store={store} history={history} />
      </Router>
    </Provider>,
    rootElement
  );
}

window.addEventListener('load', function() {
  navigator.onLine ? (isOnline = true) : (isOnline = false);
  navigator.onLine
    ? console.log('You are now back online.')
    : toast.success('Oops, we lost the internet. Let me go find it.', {
        autoClose: isOnline
      });

  window.addEventListener('online', async function(event) {
    toast.dismiss();
    toast.info('You are now back online.', { delay: 500, autoClose: 4000 });
  });

  window.addEventListener('offline', function(event) {
    isOnline = false;
    toast.success('Oops, we lost the internet. Let me go find it.', {
      autoClose: isOnline
    });
  });
});

if (process.env.NODE_ENV === 'development') {
  //serviceWorker.unregister();
  serviceWorker.register({});
  window.__REDUX_DEVTOOLS_EXTENSION__ &&
    window.__REDUX_DEVTOOLS_EXTENSION__.open();
} else if (process.env.NODE_ENV === 'production') {
  serviceWorker.register({});
}
